import { NgModule } from '@angular/core';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { CORE_FEATURE } from './core-state';
import { reducerProvider, reducerToken } from './reducers';
import { clearCmsStateFactory } from './reducers/cms.reducer';

function coreStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: {
          [CORE_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(CORE_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(coreStoreConfigFactory),
  ],
  providers: [
    reducerProvider,
    {
      provide: META_REDUCERS,
      useFactory: clearCmsStateFactory,
      multi: true,
    },
  ],
})
export class CoreStoreModule {}
